import { render, staticRenderFns } from "./GroupSalesStatus.vue?vue&type=template&id=6db5e0a7&scoped=true&"
import script from "./GroupSalesStatus.vue?vue&type=script&lang=js&"
export * from "./GroupSalesStatus.vue?vue&type=script&lang=js&"
import style0 from "./GroupSalesStatus.vue?vue&type=style&index=0&id=6db5e0a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db5e0a7",
  null
  
)

export default component.exports